<template>
  <link-fi
    v-if="cadUrl"
    :href="cadUrl"
    :size="18"
    target="_blank"
    @click="onCadLinkClicked"
  >
    {{ fields.cadLinkText.value }}
  </link-fi>
</template>

<script>
import { LinkFi } from 'atoms';

export default {
  name: 'CadLinkFi',
  components: {
    LinkFi,
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    openInDialog: {
      type: Boolean,
      default: false,
    },
    cadUrl: {
      type: String,
      default: null,
    },
  },
  emits: ['open-cad-details-dialog'],
  methods: {
    onCadLinkClicked(e) {
      if (!this.openInDialog) {
        return;
      }
      e.preventDefault();

      this.$emit('open-cad-details-dialog');
    },
  },
};
</script>
